/**
 * Created by smizrahi on 7/27/16.
 * From : http://www.datchley.name/es6-eventemitter/
 */

export default class Service {
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./js/core/services/Service.js